import React, { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as styles from './PrivacyPolicy.module.css';
import backIcon from 'url:../../assets/images/back-icon-black.webp';

import SEO from 'src/components/SEO';

export const PrivacyPolicy: FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO
        title="Privacy Policy - miniPT"
        description="Read the miniPT privacy policy to understand how we protect and manage your data."
        canonicalUrl="/privacy-policy"
      />
      <div className={styles.page}>
        {/* Back */}
        <button className={styles.backButton} onClick={() => navigate(-1)}>
          <img src={backIcon} alt="Back" className={styles.backIcon} />
          <div className={styles.backButtonText}>Back</div>
        </button>

        <div className={styles.title}>MiniPT Privacy Policy</div>

        <p className={styles.date}>Effective Date: January 16, 2026</p>

        <p>
          At MiniPT, we are committed to protecting your privacy and providing a safe and secure
          experience for all our users. This Privacy Policy sets out how we collect, use, and share
          your personal data when you use our mobile application (the &#34;App&#34;) and any other
          related services provided by MiniPT. This Privacy Policy applies to all users of the App.
        </p>

        <h3>Data Controller</h3>
        <p>
          MiniPT is the data controller of your personal data under applicable data protection laws,
          including the General Data Protection Regulation (GDPR) and the Data Protection Act 2018.
        </p>

        <h3>What Information We Collect</h3>
        <p>
          2.1 We may collect personal data, such as your name, email address, location data, fitness
          and health-related information, and other information provided by you through text fields,
          your interaction with the MiniPT chatbot (MPTChat) messaging system, and other data, to
          provide our services and improve the App&#39;s functionality.
        </p>
        <p>
          2.2 We may also collect non-personal data, such as your IP address, browser type, and
          device information, to analyze App usage and improve our services.
        </p>

        <h3>How We Use Your Information</h3>
        <p>3.1 We use your personal data to provide our services, including to:</p>
        <p>Facilitate communication between you and our team.</p>
        <p>Customize and personalize your experience with our App.</p>
        <p>Monitor the use of the App to improve and develop our services.</p>

        <p>3.2 We use your non-personal data to:</p>
        <p>Improve the performance and functionality of the App.</p>
        <p>Analyze usage patterns and trends to improve our services.</p>

        <h3>Legal Basis for Processing Your Data</h3>
        <p>4.1 We process your personal data based on one or more of the following legal bases:</p>
        <p>
          Performance of a contract: We need to process your personal data to fulfill our
          contractual obligations to you.
        </p>
        <p>Consent: We may process your personal data with your consent.</p>
        <p>
          Legitimate interests: We may process your personal data for our legitimate interests in
          improving our services and enhancing your user experience.
        </p>

        <h3>Who We Share Your Information With</h3>
        <p>5.1 We may share your personal data with:</p>
        <p>
          Our affiliates, partners, or service providers who help us to provide and improve our
          services.
        </p>
        <p>
          Law enforcement agencies, regulatory authorities, or other authorized third parties in
          response to a subpoena, court order, or other legal process.
        </p>

        <h3>Data Security and Retention</h3>
        <p>
          6.1 We take appropriate technical and organizational measures to protect your personal
          data against unauthorized or unlawful processing and against accidental loss, destruction,
          or damage.
        </p>
        <p>
          6.2 We retain your personal data for as long as necessary to fulfill the purposes for
          which it was collected, including for the purposes of satisfying any legal, accounting, or
          reporting requirements.
        </p>

        <h3>Your Rights</h3>
        <p>7.1 You have the following rights with respect to your personal data:</p>
        <p>The right to access your personal data and to receive a copy of your personal data.</p>
        <p>The right to rectify any inaccurate or incomplete personal data.</p>
        <p>The right to erase your personal data, subject to certain limitations.</p>
        <p>The right to restrict the processing of your personal data.</p>
        <p>
          The right to data portability, which allows you to receive your personal data in a
          structured, commonly used, and machine-readable format and to transmit it to another
          controller.
        </p>
        <p>The right to object to the processing of your personal data.</p>

        <p>
          7.2 You can exercise your rights by contacting us at{' '}
          <a href="mailto:Samuel@minipt.co.uk">Samuel@minipt.co.uk</a>. We will respond to your
          request as soon as possible and in any event within one month of receiving your request.
        </p>

        <h3>Changes to This Policy</h3>
        <p>
          8.1 We may update this Privacy Policy from time to time. If we make material changes to
          this Privacy Policy, we will notify you by email or by posting a notice on the App. Your
          continued use of the App after the effective date of any changes to this Privacy Policy
          constitutes your acceptance of the revised Privacy Policy.
        </p>

        <h3>9. Contact Us</h3>
        <p>
          9.1 If you have any questions or concerns about this Privacy Policy or the App, please get
          in touch with MiniPT at <a href="mailto:samuel@minipt.co.uk">samuel@minipt.co.uk</a>.
        </p>

        <h3>10. Supervisory Authority</h3>
        <p>
          10.1 You have the right to lodge a complaint with a supervisory authority, such as the
          Information Commissioner&#39;s Office (ICO) in the UK or your local data protection
          authority in the EU.
        </p>

        <h3>11. GDPR Data Protection Officer (DPO)</h3>
        <p>
          11.1 We have appointed a Data Protection Officer (DPO) to oversee our data protection
          practices. You can contact our DPO at samuel@minipt.co.uk.
        </p>

        <p>
          By using the MiniPT App and related services, you consent to our collection and use of
          your personal data in accordance with this Privacy Policy. You must not use the MiniPT App
          and related services if you do not agree to this Privacy Policy.
        </p>
      </div>
    </>
  );
};

export default PrivacyPolicy;
